import {jwtDecode} from "jwt-decode";
import {TAuthTokenPayload} from "../types";

export function getUserRoleFromToken(token: string): string {
    try {
        const decoded = jwtDecode<TAuthTokenPayload>(token);
        return decoded.role ?? "";
    } catch (error) {
        console.error("Invalid JWT token", error);
        return "";
    }
}
